"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { similars: [] };
        this.documentation = false;
    },
    onMount: function () {
        this.fetchSimilar();
    },
    fetchSimilar: async function (query) {
        try {
            const {nsi, categories} = this.input.item, {error, message, results} = await MPSRequest(`/extension/search?query=${ categories.join('+') }`);
            if (error)
                throw new Error(message);
            this.state.similars = results.filter(each => {
                return nsi != each.nsi;
            });
        } catch (error) {
            console.log('Failed fetching similar items: ', error);
            this.state.similars = [];
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Marketplace/components/ViewApp/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    Favicon_template = require("../../../Favicon.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Favicon_tag = marko_loadTag(Favicon_template),
    StarRating_template = require("../../../../../components/StarRating/index.marko"),
    StarRating_tag = marko_loadTag(StarRating_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Locale_template = require("../../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Preloader_template = require("../../../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Row_template = require("../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_loadNestedTag = require("marko/dist/runtime/helpers/load-nested-tag"),
    Row_col_nested_tag = marko_loadNestedTag("col", 1),
    marko_mergeNestedTagsHelper = require("marko/dist/runtime/helpers/merge-nested-tags"),
    marko_attrs0 = {
        "class": "padding-6"
      },
    marko_attrs1 = {
        "class": "list-inline d-inline-flex align-items-center"
      },
    marko_attrs2 = {
        "class": "px-3"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("38147c"),
    marko_node0 = marko_createElement("br", null, "14", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "text-primary"
      },
    marko_attrs4 = {
        "class": "list-inline"
      },
    marko_attrs5 = {
        "class": "px-1 py-25 m-25 border round text-muted font-small-3"
      },
    marko_attrs6 = {
        "class": "btn btn-primary btn-block text-nowrap"
      },
    marko_attrs7 = {
        "class": "btn btn-primary my-50 btn-block line-ellipsis"
      },
    marko_attrs8 = {
        "class": "btn btn-outline-primary my-50 btn-block"
      },
    marko_node1 = marko_createElement("br", null, "26", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs9 = {
        "class": "font-medium-2"
      },
    marko_attrs10 = {
        style: "padding-top:45rem;border-radius: 1000px 0 0 0",
        "class": "py-2 theme-bg"
      },
    marko_attrs11 = {
        "class": "card theme-bg"
      },
    marko_attrs12 = {
        "class": "card-content"
      },
    marko_attrs13 = {
        style: "height:120px",
        "class": "d-flex align-items-center justify-content-center"
      },
    marko_attrs14 = {
        "class": "px-1 py-75"
      },
    marko_attrs15 = {
        "class": "mb-2"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  Row_tag({
      col: [
          {
              qs: "col-3",
              hs: "col-2",
              class: "text-center py-2",
              renderBody: function(out) {
                Favicon_tag(marko_assign({}, input.item, {
                    class: "font-large-1"
                  }), out, __component, "3");
              }
            },
          {
              renderBody: function(out) {
                Row_tag({
                    col: [
                        {
                            renderBody: function(out) {
                              out.e("h5", null, "7", component, 1)
                                .t(input.item.name, component);

                              out.e("p", null, "8", component, 1)
                                .t(input.item.description, component);

                              out.be("ul", marko_attrs1, "9", component);

                              out.be("li", null, "10", component);

                              StarRating_tag({
                                  score: 3.5,
                                  color: "grey"
                                }, out, __component, "11");

                              out.ee();

                              out.e("li", marko_attrs2, "12", component, 1)
                                .e("span", marko_attrs3, "13", component, 1)
                                  .t(input.item.author.name, component);

                              out.ee();

                              out.n(marko_node0, component);

                              if (input.item.categories.length) {
                                out.be("ul", marko_attrs4, "15", component);

                                var $for$0 = 0;

                                marko_forOf(input.item.categories, function(category, index) {
                                  var $keyScope$0 = "[" + (($for$0++) + "]");

                                  out.e("li", marko_attrs5, "16" + $keyScope$0, component, 1)
                                    .t(category.toCapitalCase(), component);
                                });

                                out.ee();
                              }
                            }
                          },
                        {
                            class: "col-sm-3 col-12",
                            renderBody: function(out) {
                              const isInstalling = input.installing.nsi == input.item.nsi && input.installing.status == 'ONGOING'

                              if (!window.Extensions.isInstalled((input.item.nsi + "~") + input.item.version)) {
                                out.be("button", marko_attrs6, "18", component, null, 0, {
                                    onclick: __component.d("click", () => !isInstalling ? component.emit('install', input.item ) : false, false)
                                  });

                                Locale_tag({
                                    text: isInstalling ? "installing..." : "Install"
                                  }, out, __component, "19");

                                Preloader_tag({
                                    active: isInstalling,
                                    class: "font-medium-5 px-25"
                                  }, out, __component, "20");

                                out.ee();
                              } else {
                                const isUninstalling = input.uninstalling.nsi == input.item.nsi && input.uninstalling.status == 'ONGOING'

                                if ((!isUninstalling) && (input.item.type == "application")) {
                                  out.be("button", marko_attrs8, "21", component, null, 0, {
                                      onclick: __component.d("click", () => component.emit('run', input.item.name ), false)
                                    });

                                  Locale_tag({
                                      text: "Open"
                                    }, out, __component, "22");

                                  out.ee();
                                }

                                out.be("button", marko_attrs7, "23", component, null, 0, {
                                    onclick: __component.d("click", () => !isUninstalling ? component.emit('uninstall', input.item.nsi ) : false, false)
                                  });

                                Locale_tag({
                                    text: isUninstalling ? "uninstalling..." : "Uninstall"
                                  }, out, __component, "24");

                                Preloader_tag({
                                    active: isUninstalling,
                                    class: "font-medium-5 px-25"
                                  }, out, __component, "25");

                                out.ee();
                              }
                            }
                          }
                      ]
                  }, out, __component, "5");
              }
            }
        ]
    }, out, __component, "1");

  if (component.documentation) {
    out.n(marko_node1, component);

    out.be("div", null, "27", component);

    out.be("h5", marko_attrs9, "28", component);

    Locale_tag({
        text: "Documentation"
      }, out, __component, "29");

    out.ee();

    out.be("div", null, "30", component);

    out.h(component.documentation, component);

    out.ee();

    out.ee();
  }

  if (state.similars.length) {
    out.be("section", marko_attrs10, "31", component);

    out.be("h5", null, "32", component);

    Locale_tag({
        text: ("Similar " + input.item.type) + "s",
        class: "font-medium-1"
      }, out, __component, "33");

    out.ee();

    Row_tag(marko_mergeNestedTagsHelper({
        renderBody: function(out, $nestedTagRow$0) {
          var $for$1 = 0;

          marko_forOf(state.similars, function(each, index) {
            var $keyScope$1 = "[" + (($for$1++) + "]");

            if (each.nsi !== input.item.nsi) {
              const { name, description, nsi, version, favicon } = each

              Row_col_nested_tag({
                  qs: "col-6",
                  hs: "col-3",
                  fs: "col-2",
                  class: "cursor-pointer",
                  renderBody: function(out) {
                    out.be("div", marko_attrs11, "36" + $keyScope$1, component, null, 0, {
                        onclick: __component.d("click", () => component.emit('open', each ), false)
                      });

                    out.be("div", marko_attrs12, "37" + $keyScope$1, component);

                    out.be("div", marko_attrs13, "38" + $keyScope$1, component);

                    Favicon_tag(marko_assign({
                        width: 44
                      }, each, {
                        class: "font-large-1"
                      }), out, __component, "39" + $keyScope$1);

                    out.ee();

                    out.be("div", marko_attrs14, "40" + $keyScope$1, component);

                    out.e("p", marko_attrs15, "41" + $keyScope$1, component, 1)
                      .t(name, component);

                    out.be("div", null, "42" + $keyScope$1, component);

                    if (window.Extensions.isInstalled((nsi + "~") + version)) {
                      Locale_tag({
                          text: "Installed",
                          class: "font-small-2 float-right text-success"
                        }, out, __component, "43" + $keyScope$1);
                    }

                    StarRating_tag({
                        score: 5,
                        color: "grey"
                      }, out, __component, "44" + $keyScope$1);

                    out.ee();

                    out.ee();

                    out.ee();

                    out.ee();
                  }
                }, $nestedTagRow$0);
            }
          });
        }
      }), out, __component, "34");

    out.ee();
  }

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
